"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonSyntheticHealthDimensions = void 0;
exports.getCommonSyntheticHealthDimensionNames = getCommonSyntheticHealthDimensionNames;
const commonSyntheticHealthDimensions = exports.commonSyntheticHealthDimensions = {
  test_id: {
    Type: 'integer',
    Label: 'Test Name',
    Column: 'INT64_03',
    Popular: true,
    Shared: false
  },
  dst_address: {
    Type: 'string',
    Label: 'Address',
    Column: 'INET_00',
    Popular: true,
    Shared: false
  },
  src_agent: {
    Type: 'integer',
    Label: 'Agent',
    Column: 'INT64_01',
    Popular: true,
    Shared: false
  },
  src_agent_site_id: {
    Type: 'integer',
    Label: 'Agent Site',
    Column: 'INT23',
    Popular: true,
    Shared: false
  },
  src_agent_asn: {
    Type: 'integer',
    Label: 'Agent ASN',
    Column: 'i_src_as_name',
    FilterColumn: 'src_as',
    Popular: true,
    Shared: false
  },
  src_agent_ip: {
    Type: 'string',
    Label: 'Agent IP',
    Column: 'INET_01',
    Popular: true,
    Shared: false
  },
  src_agent_country: {
    Type: 'string',
    Label: 'Agent Country',
    Column: 'STR09',
    Popular: true,
    Shared: false
  },
  dst_agent: {
    Type: 'integer',
    Label: 'Agent',
    Column: 'INT64_11',
    Popular: true,
    Shared: false
  },
  dst_agent_site_id: {
    Type: 'integer',
    Label: 'Agent Site',
    Column: 'INT25',
    Popular: true,
    Shared: false
  },
  dst_agent_asn: {
    Type: 'integer',
    Label: 'Agent ASN',
    Column: 'i_dst_as_name',
    FilterColumn: 'dst_as',
    Popular: true,
    Shared: false
  },
  dst_agent_ip: {
    Type: 'string',
    Label: 'Agent IP',
    Column: 'INET_02',
    Popular: true,
    Shared: false
  },
  dst_agent_country: {
    Type: 'string',
    Label: 'Agent Country',
    Column: 'STR10',
    Popular: true,
    Shared: false
  },
  dst_task_target: {
    Type: 'string',
    Label: 'Task Target',
    Column: 'STR12',
    Popular: true,
    Shared: false
  },
  task_dns_resolver: {
    Type: 'string',
    Label: 'DNS Resolver',
    Column: 'INET_03',
    Popular: true,
    Shared: false
  },
  task_dns_target_hostname: {
    Type: 'string',
    Label: 'DNS Target Hostname',
    Column: 'STR11',
    Popular: true,
    Shared: false
  },
  // Label pseudo-dimensions — resolved to agent/test IDs by the backend
  ktlabel_syn_agent: {
    Type: 'integer',
    Label: 'Agent Label',
    Popular: false,
    Shared: false,
    FilterOnly: true
  },
  ktlabel_syn_test: {
    Type: 'integer',
    Label: 'Test Label',
    Popular: false,
    Shared: false,
    FilterOnly: true
  }
};
function getCommonSyntheticHealthDimensionNames(options = {}) {
  const {
    include = Object.keys(commonSyntheticHealthDimensions),
    exclude = []
  } = options;
  const dims = {};
  include.forEach(dimName => {
    if (!exclude.includes(dimName)) {
      dims[dimName] = commonSyntheticHealthDimensions[dimName];
    }
  });
  return dims;
}